import { RoomSessions, SocketState } from 'craft/types';

export interface RoomState {
  socketState: SocketState;
  sessions: RoomSessions;
  pendingMessages: Message[];
}

export interface Message extends Record<string, any> {
  type: string;
}

export enum RoomWorkerActions {
  SET_SOCKET_STATE = 'Room/SET_SOCKET_STATE',
  SET_SESSIONS = 'Room/SET_SESSIONS',
}

/**
 * Actions incoming from the websocket
 */
export enum RoomSocketActions {
  /** set all the sessions */
  SET_SESSIONS = 'SET_SESSIONS',
  /** Set only one session */
  SET_SESSION = 'SET_SESSION',

  /** Removes an existing session */
  DELETE_SESSION = 'DELETE_SESSION',
}
